// extracted by mini-css-extract-plugin
export default {"popupContainer":"styles_popupContainer__VRZrJ","childContainer":"styles_childContainer__NSX2F"};